(() => {
  document.addEventListener('keydown', event => {if(event.key==='Escape') document.querySelectorAll('.ps-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('click', event => {document.querySelectorAll('.ps-menu[open]').forEach(menu=>{if(!menu.contains(event.target)) menu.open=false;});});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r=>r.json()).then(cart=>document.querySelectorAll('[data-ps-cart-count]').forEach(el=>{el.textContent=`(${cart.item_count})`;})).catch(()=>{});
    });
  }
})();
// Keep the same document (and audio engine) for home / TROTOAR navigation.
(() => {
  if(window.__psNavigationReady)return;window.__psNavigationReady=true;
  let pending;
  const supported = url => url.origin===location.origin && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:index\.html|collection\.html|collections\/trotoar-1-0\/?)?$/i.test(url.pathname);
  async function navigate(url,push=true){
    const main=document.getElementById('MainContent');if(!main||!window.PlatonicExperience){location.assign(url.href);return;}
    pending?.abort();const controller=new AbortController();pending=controller;main.setAttribute('aria-busy','true');
    try{
      const response=await fetch(url.href,{signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});if(!response.ok)throw new Error('Navigation unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html'),nextMain=doc.getElementById('MainContent');
      if(!nextMain?.querySelector('[data-ps-experience]'))throw new Error('Use standard navigation');
      main.querySelectorAll('[data-ps-experience]').forEach(root=>window.PlatonicExperience.cleanup(root));
      main.replaceChildren(...nextMain.childNodes);document.title=doc.title;
      document.body.classList.toggle('template-index',!url.pathname.includes('collection'));
      document.body.classList.toggle('template-collection',url.pathname.includes('collection'));
      if(push)history.pushState({platonic:true},'',url.href);
      window.PlatonicExperience.scan();window.scrollTo({top:0,behavior:'instant'});main.focus({preventScroll:true});
    }catch(error){if(error.name!=='AbortError')location.assign(url.href);}
    finally{if(pending===controller)main.removeAttribute('aria-busy');}
  }
  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||window.Shopify?.designMode)return;
    const link=event.target.closest('a[href]');if(!link||link.target||link.hasAttribute('download'))return;
    const url=new URL(link.href,location.href);
    if(url.href.split('#')[0]===location.href.split('#')[0]&&url.hash)return;
    if(!document.querySelector('[data-ps-experience]')||!supported(url))return;
    event.preventDefault();navigate(url);
  });
  window.addEventListener('popstate',()=>{const url=new URL(location.href);if(document.querySelector('[data-ps-experience]')&&supported(url))navigate(url,false);else location.reload();});
})();
